<template>
  <div class="contain">
    <div
      class="header-box"
      style="color:#4C9AFF;font-size:20px;line-height: 40px;display: flex;align-items: center;justify-content: space-between;padding-right:50px;"
    >
      <el-page-header @back="goBack" content="农民工工资发放明细表"></el-page-header>
      <el-button type="primary" @click="downFile">下载</el-button>
    </div>
    <div class="box" id="printDiv" style="overflow: auto;">
      <!-- <p class="arrow">
                <span @click="changePdfPage(0)" class="turn" :class="{grey: currentPage==1}">Preview</span>
                {{currentPage}} / {{pageCount}}
                <span @click="changePdfPage(1)" class="turn" :class="{grey: currentPage==pageCount}">Next</span>
            </p>
            <pdf
                :src="src"
                :page="currentPage"
                @num-pages="pageCount=$event"
                @page-loaded="currentPage=$event"
                @loaded="loadPdfHandler">
      </pdf>-->
      <!-- <pdf src="../../assets/file/ceshi.pdf" style="width:100%;height:100%;"></pdf> -->
      <!-- <pdf ref="pdf" :src="pdfUrl" style="width: 100%;height:500px;"></pdf> -->
      <!-- <iframe src="http://192.168.1.119:18004/static/wisdom/wagePdf/202003171749501218333538.pdf" frameborder="0" style="width: 100%; height: 100%"></iframe> -->
      <!-- <div v-if="ishasPdf" style="width:100%;height:100%;overflow: auto;">
                <iframe :src="src" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
            <div v-else style="width:100%;height:100%;background:#fff;padding-top:100px;font-size:20px;">
                暂无数据
      </div>-->
      <canvas v-for="page in pages" :id="'canvas' + page" :key="page"></canvas>
    </div>
  </div>
</template>
<script>
// import pdf from 'vue-pdf'
import PDF from 'pdfjs-dist'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  // components: {pdf},
  data() {
    return {
      // currentPage: 0, // pdf文件页码
      // pageCount: 0, // pdf文件总页数
      // fileType: 'pdf', // 文件类型
      src: '',
      ishasPdf: false,

      url: '',
      // width: 100,
      pdfDoc: null,
      pages: [],
      formId: ''
    }
  },
  mounted() {
    // this.src = 'http://192.168.1.119:18004/static/wisdom/wagePdf/202003171749501218333538.pdf'
    // this.src = '/image/ceshi.pdf'

    /**
     * {data:atob(base64Str),cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',cMapPacked: true}
     */
    // this.src = pdf.createLoadingTask(src)
    // this.groupId = this.$store.state.groupId;
    // if(''==this.groupId){
    //     this.$store.commit('setGroupId');
    //     this.groupId = this.$store.state.groupId;
    // }
    // this.pdfUrl = pdf.createLoadingTask(this.src)
    // console.log(this.pdfUrl)
    // this.getData()
    // this.getAllNum()
    // this.loadPdfHandler()
    this.formId = this.$route.params.id
    var url = util.session.get('url')
    this.getFile(url)
    // this.getData()
    // this.src.then(pdf => {
    // 	this.numPages = pdf.numPages;
    // });
  },
  methods: {
    /*
     * 加载PDF文件
     * url：后台提供的pdf地址或者项目中public/pdf文件（test.pdf）
     * 在需要的位置调用 this.loadFile(url)
     * */
    loadFile(url) {
      
      PDF.getDocument({
        data: atob(url),
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.0.943/cmaps/',
        cMapPacked: true
      }).then(pdf => {
        this.pdfDoc = pdf
        this.pages = this.pdfDoc.numPages
        this.$nextTick(() => {
          this.renderPage(1)
        })
      })
    },
    // loadFile (url) {
    //     PDF.getDocument(url)
    //         .then((pdf) => {
    //         this.pdfDoc = pdf
    //         this.pages = this.pdfDoc.numPages
    //         this.$nextTick(() => {
    //             this.renderPage(1)
    //         })
    //     })
    // },
    /*
     * 渲染PDF文件
     * */
    renderPage(num) {
      this.pdfDoc.getPage(num).then(page => {
        let canvas = document.getElementById('canvas' + num)
        let ctx = canvas.getContext('2d')
        let dpr = window.devicePixelRatio || 1 // 设备像素比
        let bsr =
          ctx.webkitBackingStorePixelRatio ||
          ctx.mozBackingStorePixelRatio ||
          ctx.msBackingStorePixelRatio ||
          ctx.oBackingStorePixelRatio ||
          ctx.backingStorePixelRatio ||
          1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
        let ratio = dpr / bsr
        let viewport = page.getViewport(2.4)
        canvas.width = viewport.width * ratio // 画布大小,默认值是width:300px,height:150px
        canvas.height = viewport.height * ratio
        canvas.style.width = viewport.width + 'px' // 画布的框架大小
        canvas.style.height = viewport.height + 'px'
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        page.render(renderContext)
        if (this.pages > num) {
          this.renderPage(num + 1)
        } else {
          this.closeServerLoadingHandle()
        }
      })
    },
    //获取数据
    getData() {
      var that = this
      myHttp.findPdf({ id: this.formId }).then(function(resp) {
        if (resp.data.code == '200') {
          var url = resp.data.data.path
          url = url ? base.httpCtx + url : ''
          if (url != '') {
            that.ishasPdf = true
          } else {
            that.ishasPdf = false
          }
          //that.src = url;
          that.getFile(resp.data.data.path)
          // that.loadFile(url)
        }
      })
    },

    //获取文件流
    getFile(url) {
      let that = this
      myHttp
        .getFtp({
          fileUrl: base.httpCtx,
          fileName: url
        })
        .then(function(resp) {
          if (resp.data.code == 200) {
            var url = resp.data.data.buff
            that.loadFile(url)
          }
        })
    },
    //返回
    goBack() {
      this.$router.go(-1)
    },

    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    // changePdfPage (val) {
    //     // console.log(val)
    //     if (val === 0 && this.currentPage > 1) {
    //     this.currentPage--
    //     // console.log(this.currentPage)
    //     }
    //     if (val === 1 && this.currentPage < this.pageCount) {
    //     this.currentPage++
    //     // console.log(this.currentPage)
    //     }
    // },

    // // pdf加载时
    // loadPdfHandler (e) {
    //     this.currentPage = 1 // 加载的时候先加载第一页
    // },

    //下载
    downFile() {
      // var token = util.session.get('token')
      var token = this.$store.state.token
      window.open(
        myHttp.downloadApplyPdf +
          '?applyFormId=' +
          this.formId +
          '&accessToken=' +
          token
      )
    }
  }
}
</script>
<style scoped>
.contain {
  width: 100%;
  height: 100%;
  position: relative;
}
.header-box {
  padding: 15px 20px;
  height: 70px;
  width: 100%;
  box-shadow: 1px 2px 3px 2px #ddd;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.box {
  margin-top: 15px;
  width: 100%;
  height: calc(100% - 70px);
  /* background: #fff; */
}
.box-content {
  width: 100%;
  height: 50%;
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  margin-top: 6px;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  background: #fff;
  border-bottom: 3px solid #17b2fe;
  padding: 0 20px;
}
/* 字体颜色 */
.font-color1 {
  color: #ffbc01;
}
.font-color2 {
  color: #0085ff;
}
</style>
<style>
.build-bar span {
  margin-left: 0;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-pagination {
  background: #fff;
  padding: 15px 0;
}
.build-bar > .el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
</style>